import { useAuth } from '@/contexts/auth-context';
import { PlanCollabFeeLines } from '@/components/subscription/plan-fees/PlanCollabFeeLines';
import { formatSuccessFeeRate } from '@/libs/utils/format-success-fee-rate';
import { Stack, Text } from '@chakra-ui/react';
import { PLAN_FEE_GRID, planFeeOfferOf } from '@fluenceur/types';
import { useTranslation } from 'react-i18next';

/**
 * The fees the current plan charges, from the shared grid the server charges
 * from. An internal or partner workspace pays no platform fee at all, so it is
 * quoted none.
 */
export const CurrentPlanFees = ({
  planKey,
  currencyCode,
}: {
  /** `essential` or `growth`; anything else is priced as the free offer. */
  planKey: string | null | undefined;
  currencyCode: string | null | undefined;
}) => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const offer = planFeeOfferOf(planKey);
  const fees = PLAN_FEE_GRID[offer];
  if (user?.currentBrand?.hasSubscriptionBypass) return null;

  return (
    <Stack gap={0.5} fontSize="sm" color="fg.muted">
      <Text>
        {t('pricing.plan.affiliateFee', {
          rate: formatSuccessFeeRate(fees.successFeeBasisPoints, t('common.locale')),
        })}
      </Text>
      <PlanCollabFeeLines
        collabFee={fees.collabFee}
        giftingFeeBasisPoints={fees.giftingFeeBasisPoints}
        currencyCode={currencyCode}
      />
    </Stack>
  );
};
